import { render } from "./PatientTelehealthHeader.vue?vue&type=template&id=ab7adf4e&ts=true"
import script from "./PatientTelehealthHeader.vue?vue&type=script&lang=ts"
export * from "./PatientTelehealthHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__